// ---------------------------------------------- modules import
import { IOrderedPost } from "../firebase/common";
import { newTags } from "../helpers/tagHelper";
import firebase from "../../config/fbInit";

export interface IAuthor {
  email: string;
  name: string;
}

export interface IReader {
  id: string;
  name: string;
  email: string;
}

export interface IPost extends IOrderedPost {
  [key: string]: any;
}

const newAuthor = (): IAuthor => ({
  email: "",
  name: ""
});

export const newPost = (author?: IAuthor): IOrderedPost => ({
  id: "",
  title: "",
  data: {
    time: 0,
    version: "0",
    blocks: []
  },
  category: "",
  tags: newTags(),
  author: author ? author : newAuthor(),
  createdAt: firebase.firestore.Timestamp.now(),
  lastModified: firebase.firestore.Timestamp.now(),
  readers: []
});

// ---------------------------------------------- state interface
export interface IPostState {
  loading: boolean;
  error: string | null;
}

// ---------------------------------------------- action type enum
export enum PostActionType {
  ADD_POST_BEGIN = "ADD_POST_BEGIN",
  ADD_POST_SUCCESS = "ADD_POST_SUCCESS",
  ADD_POST_ERROR = "ADD_POST_ERROR",
  PIN_POST_BEGIN = "PIN_POST_BEGIN",
  PIN_POST_SUCCESS = "PIN_POST_SUCCESS",
  PIN_POST_ERROR = "PIN_POST_ERROR",
  UPDATE_POST_BEGIN = "UPDATE_POST_BEGIN",
  UPDATE_POST_SUCCESS = "UPDATE_POST_SUCCESS",
  UPDATE_POST_ERROR = "UPDATE_POST_ERROR",
  DELETE_POST_BEGIN = "DELETE_POST_BEGIN",
  DELETE_POST_SUCCESS = "DELETE_POST_SUCCESS",
  DELETE_POST_ERROR = "DELETE_POST_ERROR"
}

// ---------------------------------------------- action interfaces
interface IAddBegin {
  type: typeof PostActionType.ADD_POST_BEGIN;
}

interface IAddSuccess {
  type: typeof PostActionType.ADD_POST_SUCCESS;
}

interface IAddError {
  type: typeof PostActionType.ADD_POST_ERROR;
  payload: {
    error: string;
  };
}

interface IPinBegin {
  type: typeof PostActionType.PIN_POST_BEGIN;
}

interface IPinSuccess {
  type: typeof PostActionType.PIN_POST_SUCCESS;
}

interface IPinError {
  type: typeof PostActionType.PIN_POST_ERROR;
  payload: {
    error: string;
  };
}

interface IUpdateBegin {
  type: typeof PostActionType.UPDATE_POST_BEGIN;
}

interface IUpdateSuccess {
  type: typeof PostActionType.UPDATE_POST_SUCCESS;
}

interface IUpdateError {
  type: typeof PostActionType.UPDATE_POST_ERROR;
  payload: {
    error: string;
  };
}

interface IDeleteBegin {
  type: typeof PostActionType.DELETE_POST_BEGIN;
}

interface IDeleteSuccess {
  type: typeof PostActionType.DELETE_POST_SUCCESS;
}

interface IDeleteError {
  type: typeof PostActionType.DELETE_POST_ERROR;
  payload: {
    error: string;
  };
}

// ---------------------------------------------- exported action type
export type PostAction =
  | IAddBegin
  | IAddSuccess
  | IAddError
  | IPinBegin
  | IPinSuccess
  | IPinError
  | IUpdateBegin
  | IUpdateSuccess
  | IUpdateError
  | IDeleteBegin
  | IDeleteSuccess
  | IDeleteError;
